import React, { Component } from "react";
import "../../stylesheets/sideMenu.css";
import { NavLink } from "react-router-dom";
import { useTranslation } from "react-i18next";
// import localizedStrings from "../../resources/localization"
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { LogOut } from "../../global-state/actions/authAction";
function SidebarItem({ route, title, iconClass }) {
  return (
    <li className="disbleSelection">
      {" "}
      <NavLink
        to={route}
        exact
        //   className="navitem mynavitem"
        activeClassName="navitem-active disbleSelection"
      >
        <i className={iconClass}></i>
        {title}
      </NavLink>
    </li>
  );
}
function Sidebar(props) {
  const { t } = useTranslation();
  const permissions = {
    superuser: [
      {
        route: "/createBank",
        title: "bank.bank",
        icon: "fas fa-university pr-2",
      },
      {
        route: "/createBranch",
        title: "branch.branch",
        icon: "fas fa-code-branch pr-2",
      },
      {
        route: "/createUser",
        title: "CreateUser",
        icon: "fas fa-user pr-2",
      },
    ],
    "Bank User Creator": [
      {
        route: "/createUser",
        title: "CreateUser",
        icon: "fas fa-user pr-2",
      },
    ],
    "Bank configurator": [
      {
        route: "/createUser",
        title: "CreateUser",
        icon: "fas fa-user pr-2",
      },
      {
        route: "/unverified_users",
        title: "unverified",
        icon: "fas fa-user-check pr-2",
      },
    ],
    "Bank User Checker": [
      {
        route: "/unverified_users",
        title: "unverified",
        icon: "fas fa-user-check pr-2",
      },
    ],
    "Data Entry Creator": [
      {
        route: "/signatures",
        title: "signature",
        icon: "fas fa-clipboard pr-2",
      },
      {
        route: "/instructions",
        title: "instructions.instructions",
        icon: "fas fa-clipboard pr-2",
      },
      {
        route: "/scan",
        title: "home",
        icon: "fas fa-qrcode pr-2",
      },
      {
        route: "/jobs",
        title: "jobs",
        icon: "fas fa-briefcase pr-2",
      },
      {
        route: "/categories",
        title: "reports.category",
        icon: "fas fa-layer-group pr-2",
      },
      {
        route: "/documents",
        title: "documents",
        icon: "fas fa-file-alt pr-2",
      },
    ],
    "Data Entry Checker": [
      {
        route: "/checkSignature",
        title: "scanCheck.scanCheck",
        icon: "fas fa-user-check pr-2",
      },
      {
        route: "/jobs",
        title: "jobs",
        icon: "fas fa-briefcase pr-2",
      },
      {
        route: "/checkCategories",
        title: "category.check",
        icon: "fas fa-layer-group pr-2",
      },
      {
        route: "/checkInstructions",
        title: "instructions.check",
        icon: "fas fa-clipboard pr-2",
      },
      {
        route: "/checkDocuments",
        title: "checkDocuments",
        icon: "fas fa-file-alt pr-2",
      },
    ],
    Auditor: [
      {
        route: "/search",
        title: "sigSearch",
        icon: "fas fa-search pr-2",
      },
    ],
  };
  return (
    <aside className="my-menu">
      <ul className="side-list">
        {permissions[props.user.groups]?.map((route) => {
          return (
            <SidebarItem
              route={route.route}
              title={t(route.title)}
              iconClass={route.icon}
            />
          );
        })}
      </ul>
      {/* <li onClick={props.LogOut} className="logOutSide">
        <a href="/">
          <i className="fas fa-sign-out-alt pr-2"></i>Logout
        </a>
      </li> */}
    </aside>
  );
}

const mapStateToProps = (state) => ({
  isAuth: state.auth.isAuth,
  user: state.auth.user,
});
const mapDispatchToProps = (dispatch) => {
  return bindActionCreators({ LogOut }, dispatch);
};
export default connect(mapStateToProps, mapDispatchToProps)(Sidebar);
